import PropTypes from "prop-types";
import React from "react";
import { useTranslation } from "react-i18next";
import SimulationTooltip from "../SimulationTooltip";
import Card from "./Card";
import Transactions from "./Transactions";

function BalanceCheckerResult(props) {
  const { card, showEndOfLife, onBack } = props;

  // Contexts
  const { t: translate } = useTranslation();

  // Render
  return (
    <div>
      {/* RESULTS */}
      <Card card={card} />
      <Transactions card={card} showEndOfLife={showEndOfLife} />

      {/* GO BACK BUTTON */}
      <form onSubmit={onBack}>
        <span style={{ color: "rgb(0, 0, 0)" }}>
          <SimulationTooltip title=".btn .btn-submit">
            <input
              className="btn btn-submit"
              type="submit"
              value={translate("anotherCard")}
            />
          </SimulationTooltip>
        </span>
      </form>
    </div>
  );
}

BalanceCheckerResult.propTypes = {
  showEndOfLife: PropTypes.bool,
  onBack: PropTypes.func.isRequired,
  card: PropTypes.shape({
    number: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
      .isRequired,
    status: PropTypes.string.isRequired,
    balance: PropTypes.number.isRequired,
    currency: PropTypes.string.isRequired,
    expirationDate: PropTypes.string.isRequired,
    product: PropTypes.shape({
      name: PropTypes.string.isRequired,
    }).isRequired,
  }).isRequired,
};

BalanceCheckerResult.defaultProps = {
  showEndOfLife: false,
};

export default BalanceCheckerResult;
